<template>
  <div class="row">
    <div class="col-sm-6 col-6 px-05 mt-1">
      <div class="card text-center mb-1 h-150">
        <div
          class="
            card-body
            py-2
            d-flex
            align-items-center
            justify-content-center
            m-0
          "
        >
          <div class="right col-auto text-center role-count-area">
            <div class="text-muted font-size-sm">
              {{ $t("dashboard.user_institution_count") }}
            </div>
            <h4 v-if="!institutionsBranchesLoading" class="mb-0 count">
              {{ totalInstitutions }}
            </h4>
            <h4 v-else><loading-box></loading-box> </h4>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-6 col-6 px-05 mt-1">
      <div class="card text-center mb-1 h-150">
        <div
          class="
            card-body
            py-2
            d-flex
            align-items-center
            justify-content-center
            m-0
          "
        >
          <div class="right col-auto text-center role-count-area">
            <div class="text-muted text-center">
              {{ $t("dashboard.user_branch_count") }}
            </div>
            <h4 v-if="!institutionsBranchesLoading" class="mb-0 count">{{ totalBranch }}</h4>
            <h4 v-else><loading-box></loading-box></h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingBox from "@/assets/components/loader/LoadingBox";
import baseModule, {
  ERROR,
  MODULE_NAME,
  INSTITUTIONS_BRANCHES,
  GET_INSTITUTIONS_BRANCHES,
  GET_INSTITUTIONS_BRANCHES_LOADING,
  SUCCESS,
} from "@/core/services/store/dashboard.module";
import store from "@/core/services/store";

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "InstitutionWidget",
  components:{
    LoadingBox,
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(_MODULE_NAME, baseModule);
  },
  data() {
    return {};
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    institutionsBranchesLoading() {
      return store.getters[_MODULE_NAME + "/" + GET_INSTITUTIONS_BRANCHES_LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    institutionsBranches() {
      return store.getters[_MODULE_NAME + "/" + INSTITUTIONS_BRANCHES];
    },
    totalInstitutions() {
      let institutionsBranches = this.institutionsBranches;
      if (!institutionsBranches) return 0;
      return institutionsBranches.institutions_count
    },
    totalBranch() {
      let institutionsBranches = this.institutionsBranches;
      if (!institutionsBranches) return 0;
      return institutionsBranches.branchesCount
    },
  },
  mounted() {
    this.filterResults();
  },
  methods: {
    filterResults() {
      this.$store.dispatch(_MODULE_NAME + "/" + GET_INSTITUTIONS_BRANCHES, {});
    },
  },
};
</script>